import React, { useState } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { useStyles } from './estilos';
import ElementoCardHeader from './ElementoCardHeader';
import { candidaturasEleccion } from 'constantes/globalsStates';
import { Visibility } from '@mui/icons-material';
import Calendario from 'pages/calendario';
import ListadoDeEspaciosAsignados from './ListadoDeEspaciosAsignados';

const CardHeader = ({presupuestoPlanMedios, eventoElectoralGlobal}) => {
  const classes = useStyles();
  const [abrirModal, setAbrirModal] = useState(false);
  const cerrarModal= () => { setAbrirModal(false) };
  const handleClick= () => { setAbrirModal(true) };

  return (
    <>
      <Typography className={classes.titulo}>Plan de medios - {eventoElectoralGlobal === 1 ? "Primera" : "Segunda" } Vuelta 2023 </Typography>
      <div className={classes.contenedorButton}>
        <Button variant="contained" color="primary" className={classes.button} onClick={handleClick}>
            <Visibility /> Ver espacios asignados
        </Button>
      </div>
      <Grid container justifyContent={"space-around"} alignItems={"center"} spacing={2} >
      {presupuestoPlanMedios?.map( ({tipo_eleccion_id, montoTotal}) => (
        <ElementoCardHeader key={tipo_eleccion_id} tipoCargo={candidaturasEleccion[tipo_eleccion_id]} monto={`Q. ${montoTotal}`}/>
      ))}
      </Grid>
      {abrirModal && (
            <ListadoDeEspaciosAsignados
                openFullScreenDialog={abrirModal}
                handleClose={cerrarModal}
                title={"Detalle de los espacios asignados"}
            />
        )}
    </>
  );
}

export default CardHeader;